import api from '@/services/api/pages.api'

export default {
  state: {
    uploadPage: null
  },
  mutations: {
    setUploadPage (state, payload) {
      state.uploadPage = payload
    }
  },
  actions: {
    loadUploadPage ({ commit }, payload) {
      return api.getPageBySlug(payload).then(({ data }) => {
        commit('setUploadPage', data.page)
      })
    }
  },
  getters: {
    getUploadPage (state) {
      return state.uploadPage
    }
  }
}
